export default {
    refs:{}
}


// WEBPACK FOOTER //
// ./src/api/common_data.js